/**
 * "What should your model do next?" — SaaS customer-intents modal
 * (Figma 9036-10012) and the "Contact us" tooltips that open it
 * (Figma 9035-9521).
 *
 * On SaaS only Classification and the non-agentic autonomy level are
 * self-serve; the other task types / levels are disabled and point here.
 */

export const CUSTOMER_INTENT_MODAL_WIDTH = 600;
export const CUSTOMER_INTENT_MODAL_TITLE = 'What should your model do next?';

export const CONTACT_US_LINK_LABEL = 'Contact us';
export const CONTACT_US_TASK_TYPE = 'Contact us to enable this task type';
export const CONTACT_US_AGENTIC = 'Contact us to enable agentic capabilities';

export const CUSTOMER_INTENT_FEATURES_LABEL = 'Tell us which features you would like to use';
export const CUSTOMER_INTENT_AUTONOMY_LABEL = 'Autonomy level you would like to reach';
export const CUSTOMER_INTENT_SOMETHING_ELSE_LABEL = 'Something else..';
export const CUSTOMER_INTENT_SOMETHING_ELSE_PLACEHOLDER = 'What are you trying to build?';
/** Mirrors ``MAX_SOMETHING_ELSE_LENGTH`` in ``backend/app/customer_intents/service.py``. */
export const CUSTOMER_INTENT_SOMETHING_ELSE_MAX_LENGTH = 5000;

/**
 * Feature cards (multi-select). `value` is the ``RequestedFeature`` wire enum;
 * `iconType` is the Spark ``TaskTypeIcon`` tile shown on the card.
 */
export const CUSTOMER_INTENT_FEATURES = [
    {
        value: 'entity_extraction',
        label: 'Entity Extraction',
        description: 'Pull names, dates and other spans out of text',
        iconType: 'extraction',
    },
    {
        value: 'summarization',
        label: 'Summarization',
        description: 'Condense long documents into short summaries',
        iconType: 'summarization',
    },
    {
        value: 'content_generation',
        label: 'Content Generation',
        description: 'Write new text from your instructions',
        iconType: 'content-generation',
    },
];

/** Autonomy tiles (single-select). `value` is the ``RequestedAutonomyLevel`` wire enum. */
export const CUSTOMER_INTENT_AUTONOMY_LEVEL_NONE = 'none';
export const CUSTOMER_INTENT_AUTONOMY_LEVELS = [
    { value: CUSTOMER_INTENT_AUTONOMY_LEVEL_NONE, label: "I don't need it" },
    { value: 'one_tool_call', label: 'Agent has one tool call per intent' },
    { value: 'agent_decides', label: 'Agent decides which tools to call' },
    { value: 'open_ended', label: 'Agent can explore, open-ended goal' },
];

export const CUSTOMER_INTENT_SENT_MESSAGE =
    "Thanks! We'll be in touch about enabling these capabilities.";
export const CUSTOMER_INTENT_SEND_FAILED_MESSAGE = 'Could not send your request. Please try again.';

/**
 * Whether a submission carries anything worth filing — a feature, an agentic
 * autonomy level, or non-blank free text. Mirrors the backend's 422 rule so
 * the Send button is disabled instead of surfacing a validation error.
 */
export const hasCustomerIntentContent = ({ features, autonomyLevel, somethingElse }) =>
    (features?.length ?? 0) > 0 ||
    (autonomyLevel != null && autonomyLevel !== CUSTOMER_INTENT_AUTONOMY_LEVEL_NONE) ||
    Boolean(somethingElse?.trim());
